import api from './api';
import { BOOKING_API } from '../utils/constants';

/**
 * ⚠️ SAARA PAISA PAISE MEIN. 50000 = ₹500
 *    Dikhane ke liye utils/money.js ka formatPaise() use karo.
 */

// Create booking
export const createBooking = async (bookingData) => {
    const response = await api.post(
        `${BOOKING_API}/create`, bookingData);
    return response.data;
};

// Get booking by ID
export const getBookingById = async (id) => {
    const response = await api.get(`${BOOKING_API}/${id}`);
    return response.data;
};

// Get bookings by user
export const getBookingsByUser = async (userId) => {
    const response = await api.get(
        `${BOOKING_API}/user/${userId}`);
    return response.data;
};

// Get bookings by poojari
export const getBookingsByPoojari = async (poojariId) => {
    const response = await api.get(
        `${BOOKING_API}/poojari/${poojariId}`);
    return response.data;
};

// Get all bookings - admin
export const getAllBookings = async () => {
    const response = await api.get(`${BOOKING_API}/all`);
    return response.data;
};

// Update booking
export const updateBooking = async (id, bookingData) => {
    const response = await api.put(
        `${BOOKING_API}/update/${id}`, bookingData);
    return response.data;
};

/**
 * Poojari ne booking ACCEPT ki (pooja se PEHLE).
 *
 * ⚠️ Ye completion wala confirm NAHI hai - wo
 * poojariMarkComplete() hai.
 */
export const confirmBooking = async (id) => {
    const response = await api.put(
        `${BOOKING_API}/confirm/${id}`, {});
    return response.data;
};

// Cancel booking - user
export const cancelBooking = async (id, reason) => {
    const response = await api.put(
        `${BOOKING_API}/cancel/${id}`,
        { cancellationReason: reason });
    return response.data;
};

// Reject booking - poojari (accept karne se pehle)
export const rejectBooking = async (id, reason) => {
    const response = await api.put(
        `${BOOKING_API}/reject/${id}`,
        { cancellationReason: reason });
    return response.data;
};


// Poojari accept karne ke BAAD cancel kare
//
// ⚠️ rejectBooking() se alag hai. Reject PENDING booking pe hota
// hai - kisi ka nuksaan nahi. Ye CONFIRMED pe hai: user ko poora
// refund jaata hai aur poojari par cancellation fee lagti hai.
//
// ⚠️ Pooja se 24 ghante ke andar backend mana kar dega.
export const poojariCancelBooking = async (id, reason) => {
    const response = await api.put(
        `${BOOKING_API}/poojari-cancel/${id}`,
        { cancellationReason: reason });
    return response.data;
};
// ============================================================
// BOTH-SIDE COMPLETION
//
// Purana completeBooking() aur markCashReceived() HATA diye gaye.
//
// Purana /complete payment check hi nahi karta tha - poojari
// "Done" dabaye aur booking COMPLETED ho jaati thi, chahe paisa
// aaya ho ya nahi. Aur /cash-received ek alag rasta tha jispe koi
// check nahi tha.
//
// Ab dono ka kaam poojariMarkComplete() mein aa gaya hai.
// ============================================================

/**
 * POOJARI: "pooja ho gayi"
 *
 * ⚠️ Call karne se PEHLE booking.remainingAmount dekho:
 *
 *   remainingAmount > 0  -> popup dikhao:
 *                           "Kya aapko ₹X mil gaye?"
 *                           Haan -> cashReceived = true
 *                           Nahi -> cashReceived = false
 *
 *   remainingAmount == 0 -> popup nahi, seedha call
 *                           (cashReceived ignore hoga)
 *
 * cashReceived = false bhejne pe booking Active hi rehti hai -
 * poojari baad mein wapas aake confirm kar sakta hai.
 *
 * @param id           booking id
 * @param cashReceived popup ka jawab
 */
export const poojariMarkComplete = async (id, cashReceived = false) => {
    const response = await api.put(
        `${BOOKING_API}/poojari-complete/${id}?cashReceived=${cashReceived}`,
        {});
    return response.data;
};

/**
 * USER: "haan, pooja hui"
 *
 * ⚠️ Payment poora na hua ho to backend 4xx dega saaf message ke
 * saath - wahi message user ko dikha dena.
 *
 * Cash booking mein:  "Waiting for the Poojari to confirm..."
 * Online booking mein: "Please complete your payment of Rs X..."
 *
 * Doosre case mein user ko "Pay now" button dikhana chahiye.
 */
export const userConfirmComplete = async (id) => {
    const response = await api.put(
        `${BOOKING_API}/user-confirm/${id}`, {});
    return response.data;
};

// ============================================================

/**
 * Record payment.
 *
 * ⚠️ Param ka naam ab "amountInPaise" hai, "amount" nahi.
 * Backend ne naam JAAN-BOOJH KE badla - purana caller ?amount=500
 * bhejta tha (matlab ₹500), aur naya backend usko 500 paise = ₹5
 * samajh leta. 100 guna galti, bina kisi error ke.
 *
 * ⚠️ Ye normally frontend se call NAHI hota - payment-service
 * khud booking-service ko batata hai jab payment verify hota hai.
 */
export const recordPayment = async (id, amountInPaise) => {
    const response = await api.put(
        `${BOOKING_API}/record-payment/${id}?amountInPaise=${amountInPaise}`,
        {});
    return response.data;
};

// Get booked time slots for a poojari on a date
export const getBookedSlots = async (poojariId, date) => {
    const response = await api.get(
        `${BOOKING_API}/booked-slots/${poojariId}?date=${date}`);
    return response.data;
};

// Total bookings by user
export const getTotalBookingsByUser = async (userId) => {
    const response = await api.get(
        `${BOOKING_API}/count/user/${userId}`);
    return response.data;
};

// Total bookings by poojari
export const getTotalBookingsByPoojari = async (
        poojariId) => {
    const response = await api.get(
        `${BOOKING_API}/count/poojari/${poojariId}`);
    return response.data;
};

/**
 * Poojari ka earnings breakdown.
 * ⚠️ received aur pending PAISE mein aate hain.
 */
export const getEarningsSummary = async (poojariId) => {
    const response = await api.get(
        `${BOOKING_API}/earnings/poojari/${poojariId}`);
    return response.data;
};

// ===== POOJARI CALENDAR BLOCK =====
//
// ⚠️ Poojari ko OFFLINE pooja bhi milti hai. Pehle wo app mein
// wo din block nahi kar sakta tha - user us din book karta,
// poojari reject karta, aur USER ka bharosa tootta.

// Poojari ke aane wale blocks
export const getBlockedSlots = async (poojariId) => {
    const response = await api.get(
        `${BOOKING_API}/blocked-slots/poojari/${poojariId}`);
    return response.data;
};

// Samay block karo
//
// ⚠️ startTime/endTime na bhejo to POORA DIN block hota hai.
export const blockSlot = async (
    poojariId, date, startTime, endTime, reason) => {

    const params = new URLSearchParams();
    params.append('poojariId', poojariId);
    params.append('date', date);
    if (startTime) params.append('startTime', startTime);
    if (endTime) params.append('endTime', endTime);
    if (reason) params.append('reason', reason);

    const response = await api.post(
        `${BOOKING_API}/blocked-slots?${params.toString()}`);
    return response.data;
};

// Block hatao
export const unblockSlot = async (blockId) => {
    const response = await api.delete(
        `${BOOKING_API}/blocked-slots/${blockId}`);
    return response.data;
};


/**
 * Booking se pehle ka hisaab — samagri ka 3% ismein juda hota hai.
 *
 * ⚠️ Frontend ko apna jod NAHI lagana chahiye. Wo rate sirf
 *    backend ko pata hai.
 */
export const getBookingQuote = async (poojariId, poojaType, samagriIncluded) => {
    const response = await api.get(`${BOOKING_API}/quote`, {
        params: { poojariId, poojaType, samagriIncluded }
    });
    return response.data;
};

/**
 * Poojari ka fee-itihaas — "bakaya kahan se aaya".
 *
 * ⚠️ Sirf wo poojari khud ya admin. Guard backend mein hai.
 */
export const getFeeHistory = async (poojariId) => {
    const response = await api.get(`${BOOKING_API}/fee-history/${poojariId}`);
    return response.data;
};

/**
 * Multi-day pooja ke liye - ye range khaali hai ya nahi.
 *
 * ⚠️ Date chunte hi poochte hain. Bina iske user 3 step bhar ke
 *    aakhir mein "already booked on 25 Sep" dekhta hai - aur wo
 *    bura anubhav hai.
 */
export const isRangeAvailable = async (poojariId, from, days) => {
    const response = await api.get(`${BOOKING_API}/range-available`, {
        params: { poojariId, from, days }
    });
    return response.data;
};